export default __webpack_public_path__ + "static/media/resource-image_led.8ebd3b88.png";